import { useState, useEffect } from 'react';
import { isStandalone, getDisplayMode, addDisplayModeListener } from '../utils/pwaUtils';

/**
 * React hook to detect if the app is running as a PWA (standalone mode)
 * @returns {Object} Object containing PWA status information
 */
export const usePWAStatus = () => {
    const [isPWA, setIsPWA] = useState(isStandalone());
    const [displayMode, setDisplayMode] = useState(getDisplayMode());
    
    useEffect(() => {
        // Listen for display mode changes
        const cleanup = addDisplayModeListener((newDisplayMode) => {
            setDisplayMode(newDisplayMode);
            setIsPWA(newDisplayMode === 'standalone' || newDisplayMode === 'fullscreen');
        });
        
        return cleanup;
    }, []);
    
    return {
        isPWA,
        displayMode,
        isStandalone: isPWA,
        isBrowser: !isPWA
    };
};

/**
 * React hook to detect if the current device/browser supports adding to home screen
 * @returns {boolean} true if supported, false otherwise
 */
export const useAddToHomeScreenSupport = () => {
    const [isSupported, setIsSupported] = useState(false);
    
    useEffect(() => {
        // Check if it's iOS Safari
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        
        // Check if it's Android Chrome
        const isAndroid = /Android/.test(navigator.userAgent);
        const isChrome = /Chrome/.test(navigator.userAgent);
        
        setIsSupported((isIOS && isSafari) || (isAndroid && isChrome));
    }, []);
    
    return isSupported;
};